import { useContextualBrowseEnabled } from '../hooks/useContextualBrowseEnabled'

export const BrowseText = ({ control }: { control: string }) => {
  const { enabled } = useContextualBrowseEnabled()

  if (!enabled) return control

  return <p>{`Placeholder category`} </p>
}
